module.exports = __webpack_public_path__ + "r-v3/img/ico_arrowRight_white.16879852.svg";